/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  addDecoderSizePrefix,
  addEncoderSizePrefix,
  combineCodec,
  getBooleanDecoder,
  getBooleanEncoder,
  getI64Decoder,
  getI64Encoder,
  getStructDecoder,
  getStructEncoder,
  getU32Decoder,
  getU32Encoder,
  getUtf8Decoder,
  getUtf8Encoder,
  type Codec,
  type Decoder,
  type Encoder,
} from "@solana/kit";

/** Cross-platform identity mapping */
export type ExternalIdentifier = {
  platform: string;
  externalId: string;
  verified: boolean;
  verifiedAt: bigint;
};

export type ExternalIdentifierArgs = {
  platform: string;
  externalId: string;
  verified: boolean;
  verifiedAt: number | bigint;
};

export function getExternalIdentifierEncoder(): Encoder<ExternalIdentifierArgs> {
  return getStructEncoder([
    ["platform", addEncoderSizePrefix(getUtf8Encoder(), getU32Encoder())],
    ["externalId", addEncoderSizePrefix(getUtf8Encoder(), getU32Encoder())],
    ["verified", getBooleanEncoder()],
    ["verifiedAt", getI64Encoder()],
  ]);
}

export function getExternalIdentifierDecoder(): Decoder<ExternalIdentifier> {
  return getStructDecoder([
    ["platform", addDecoderSizePrefix(getUtf8Decoder(), getU32Decoder())],
    ["externalId", addDecoderSizePrefix(getUtf8Decoder(), getU32Decoder())],
    ["verified", getBooleanDecoder()],
    ["verifiedAt", getI64Decoder()],
  ]);
}

export function getExternalIdentifierCodec(): Codec<
  ExternalIdentifierArgs,
  ExternalIdentifier
> {
  return combineCodec(
    getExternalIdentifierEncoder(),
    getExternalIdentifierDecoder(),
  );
}
